module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SD-a892be5eee6aa32f976386f6f3976099.png";